import { BaseApi, Environment } from '@nextroll/ar-base-api';

const contactsApi = new BaseApi('/audience/v1/contact_lists', {
    environment: (process.env.ENVIRONMENT || 'development') as Environment,
});

export default contactsApi;
